import * as React from 'react';
import { connect } from 'react-redux';
import {getAuthority} from 'store';
import {IStateStore} from 'models/global';
import {hasAuth} from 'utils/auth'
import {ReactNode} from "react";
import {Exception403} from 'components/Exception';
import {withRouter, RouteComponentProps} from "react-router";

interface IAuthorizedProps extends RouteComponentProps{
  isPage?: boolean;
  permission: boolean;
  children: ReactNode;
  tips?: string
}

function Index({permission, children, isPage, tips}: IAuthorizedProps) {
  if (permission) {
    return <>{children}</>;
  }
  if (isPage) {
    return <Exception403/>;
  }
  return <span>{tips || ''}</span>;
}

const mapStateToProps = (state: IStateStore, {authority}: {authority: number[]} ) => {
  return {
    permission: hasAuth(getAuthority(state), authority),
  };
};

export default withRouter(connect(mapStateToProps)(Index));

